import { storageFactory } from "storage-factory";

const handleSessionStore = (
  requestData: Record<string, unknown>,
  eventType: string,
) => {
  const sessionStorage = storageFactory(() => window.sessionStorage);

  const sessionItems = sessionStorage.getItem(eventType);
  let arrayItems = [];

  if (sessionItems) {
    arrayItems = JSON.parse(sessionItems);
  }

  if (
    !arrayItems ||
    arrayItems.length === 0 ||
    arrayItems.filter(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (x: any) => JSON.stringify(x) === JSON.stringify(requestData),
    ).length === 0
  ) {
    arrayItems.push(requestData);
    sessionStorage.setItem(eventType, JSON.stringify(arrayItems));
  }
};

export const addPromotedBrandCategoryAdToSessionStorage = async (
  eventType: string,
  adId?: number,
  brandIds?: number[],
  categoryId?: number,
  categoryName?: string,
  relativeUrl?: string,
) => {
  const requestData = {
    AdId: adId,
    BrandIds: brandIds,
    CategoryId: categoryId,
    CategoryName: categoryName,
    RelativeUrl: relativeUrl,
  };

  handleSessionStore(requestData, eventType);
};

export const addPromotedProductAdToSessionStorage = async (
  eventType: string,
  adId?: number,
  itemNumber?: string,
) => {
  const requestData = {
    AdId: adId,
    ItemNumber: itemNumber,
  };

  handleSessionStore(requestData, eventType);
};

export const addBrandLogoAdToSessionStorage = async (
  brandId: number,
  categoryId: number,
) => {
  const requestData = {
    brandId,
    categoryId,
  };

  handleSessionStore(requestData, "PhotoGridPromotedBrandLogo");
};

export const addPhotoGridPromotedBrandSpotlightToSessionStorage = (
  adId?: number,
  brandIds?: number[],
) => {
  const requestData = {
    AdId: adId,
    BrandIds: brandIds,
  };

  handleSessionStore(requestData, "PhotoGridPromotedBrandSpotlight");
};
